<div
  class="rating {{ componentClassNames }}"
  tabindex="0"
  (keydown)="onKeyDown($event)"
  (mouseleave)="onStopHover()"
>
  <div class="label-value">{{ this.labelText }}</div>
  <div class="star-container">
    @for (index of stars; track index) {
      <div
        class="star"
        (click)="setValue(index)"
        (mouseenter)="onStartHover(index)"
      >
        <svg class="star-empty">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="assets/images/star-rating.icons.svg#star-empty"
          ></use>
        </svg>
        <svg class="star-half">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="assets/images/star-rating.icons.svg#star-half"
          ></use>
        </svg>
        <svg class="star-filled">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="assets/images/star-rating.icons.svg#star-filled"
          ></use>
        </svg>
      </div>
    }
  </div>
</div>
